import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editDark.svg";
import Accumulations from "../../Accumulations/Accumulations";
import { CustomButton } from "../../../../../common/components/functional/customButton/CustomButton";
import { AccessRightContext } from "../../../../user/AccessRightProvider";

type Props = {
  startDate: string;
  endDate: string;
  employmentId: string;
  continuousEmploymentId: string;
  canEdit: boolean;
};

const EmploymentAccums = ({
  startDate,
  endDate,
  employmentId,
  continuousEmploymentId,
  canEdit,
}: Props) => {
  const [edit, setEdit] = useState(false);
  const [editDisabled, setEditDisabled] = useState(true);

  const { canEditAccumulations } = useContext(AccessRightContext);

  const { t } = useTranslation();

  const methods = useForm({
    defaultValues: {
      accumulation: "",
      dateFrom: startDate ? new Date(startDate) : null,
      dateTo: endDate ? new Date(endDate) : null,
    },
    mode: "onChange",
  });

  useEffect(() => {
    methods.setValue("dateFrom", startDate ? new Date(startDate) : null);
    methods.setValue("dateTo", endDate ? new Date(endDate) : null);
  }, [startDate, endDate, methods]);

  const onEdit = () => setEdit(true);
  const onClose = () => setEdit(false);

  return (
    <FormSection
      title={t("talentProfile:accumulations")}
      readOnly={!canEdit}
      customButton={
        <CustomButton
          accessRightChecks={[canEditAccumulations]}
          disabled={editDisabled}
          sx={{ borderRadius: "15px", height: "30px" }}
          startIcon={<EditIcon color="primary" />}
          onClick={onEdit}
          variant="outlined"
        >
          {t("common:edit")}
        </CustomButton>
      }
    >
      <FormProvider {...methods}>
        <Accumulations
          accumulationType="employment"
          onClose={onClose}
          edit={edit}
          onEdit={onEdit}
          xs={[2, 10]}
          setEditDisabled={setEditDisabled}
          employmentId={employmentId}
          continuousEmploymentId={continuousEmploymentId}
        />
      </FormProvider>
    </FormSection>
  );
};

export default EmploymentAccums;
